import Config from 'utils/getEnvConfig';
import axios from 'axios';
import { getCookie } from 'utils/cookieStore';

const {
  MAILCHIMP: { AUDIENCE_ID, PRIVATE_SERVER_URL, PRIVATE_SERVER_KEY },
} = Config;
/* eslint-disable  */

const getUserStatus = email => {
  return axios.get(`${PRIVATE_SERVER_URL}get_subscription/${AUDIENCE_ID}/${email}`, {
    headers: {
      key03: PRIVATE_SERVER_KEY,
    }
  });
};

const subscribe = (email, contentList) => {
  const brand = getCookie('brand') || 'none';
  return axios.post(`${PRIVATE_SERVER_URL}subscribe`, {
    audience: AUDIENCE_ID,
    email,
    brand,
    contentList,
  }, {
      headers: {
        key03: PRIVATE_SERVER_KEY,
      }
    }).then(response => {
      return new Promise((resolve, reject) => {
        if (response.status >= 200 && response.status < 300) {
          resolve(response);
        } else {
          reject(response);
        }
      });
    }).catch(error => {
      return new Promise((_, reject) => {
        reject(error.response);
      });
    });
};

const updateSubscription = (email, contentList, oldEmail = null) => {
  const brand = getCookie('brand') || 'none';
  return axios.put(`${PRIVATE_SERVER_URL}subscribe`, {
    audience: AUDIENCE_ID,
    email,
    brand,
    contentList,
    oldEmail,
  }, {
      headers: {
        key03: PRIVATE_SERVER_KEY,
      }
    }).then(response => {
      return new Promise((resolve, reject) => {
        if (response.status >= 200 && response.status < 300) {
          resolve(response);
        } else {
          reject(response);
        }
      });
    }).catch(error => {
      return new Promise((_, reject) => {
        reject(error.response);
      });
    });
};

const patchSubscriptionBrand = (email) => {
  const brand = getCookie('brand') || 'none';
  return axios.patch(`${PRIVATE_SERVER_URL}subscribe`, {
    audience: AUDIENCE_ID,
    email,
    brand,
  }, {
      headers: {
        key03: PRIVATE_SERVER_KEY,
      }
    }).then(response => {
      return new Promise((resolve, reject) => {
        if ((response.status >= 200 && response.status < 300) ||
          response.status === 404) {
          resolve(response);
        } else {
          reject(response);
        }
      });
    }).catch(error => {
      return new Promise((resolve, reject) => {
        if (error.response.status === 404) {
          resolve();
        } else {
          reject(error.response);
        }
      });
    });
};

const unsubscribe = email => {
  return axios.post(`${PRIVATE_SERVER_URL}unsubscribe`, {
    audience: AUDIENCE_ID,
    email,
  }, {
      headers: {
        key03: PRIVATE_SERVER_KEY,
      }
    });
};

export default {
  getUserStatus,
  subscribe,
  updateSubscription,
  patchSubscriptionBrand,
  unsubscribe,
};
